const LOGO_URL = 
    "https://img.freepik.com/free-vector/food-shopping-logo-template-design_460848-10299.jpg?size=626&ext=jpg";

const CDN_URL = 
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";



export {CDN_URL, LOGO_URL};
